export const notMobile = 'only screen and (min-width: 1023px)'

export const smallMobile = 'screen and (max-width: 320px)'

export default {
  notMobile,
  smallMobile,
}
